// extracted by mini-css-extract-plugin
module.exports = {"animate":"Labels_animate__UH_C4","fly":"Labels_fly__3CqaC"};